import CampaignListTable from "./campaignListTable.container"

export default CampaignListTable
